'use client';

import parse, {
  type DOMNode,
  domToReact,
  type Element as DomElement,
  HTMLReactParserOptions,
} from 'html-react-parser';
import Link from 'next/link';

import { mapBackendPath } from '~/lib/utils/link';

interface WysiwygContentProps {
  html: string;
  mapPath?: (backendPath: string) => string;
}

const WysiwygString = ({
  html,
  mapPath = mapBackendPath,
}: WysiwygContentProps) => {
  const backendOrigin = process.env.NEXT_PUBLIC_BACKEND_ORIGIN;

  if (!backendOrigin) {
    console.warn('Missing NEXT_PUBLIC_BACKEND_ORIGIN');

    return <>{parse(html)}</>;
  }

  const opts: HTMLReactParserOptions = {
    replace: (node: DOMNode) => {
      if (node.type === 'tag' && (node as DomElement).name === 'a') {
        const el = node as DomElement;
        const href = el.attribs.href;

        if (typeof href === 'string') {
          if (href.startsWith(backendOrigin)) {
            const backendPath = href.slice(backendOrigin.length);
            const newPath = mapPath(backendPath);

            return (
              <Link href={newPath} prefetch={false}>
                {domToReact(el.children as DOMNode[], opts)}
              </Link>
            );
          }

          if (href.startsWith('/')) {
            const newPath = mapPath(href);

            return (
              <Link href={newPath} prefetch={false}>
                {domToReact(el.children as DOMNode[], opts)}
              </Link>
            );
          }
        }
      }
    },
  };

  return <>{parse(html, opts)}</>;
};

export default WysiwygString;
